import { render } from "./FAQAccordion.vue?vue&type=template&id=612d51d3&scoped=true"
import script from "./FAQAccordion.vue?vue&type=script&lang=js"
export * from "./FAQAccordion.vue?vue&type=script&lang=js"

import "./FAQAccordion.vue?vue&type=style&index=0&id=612d51d3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612d51d3"]])

export default __exports__